import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./mobile.css";
import { initSentry } from "./lib/monitoring";
import { initWebVitals } from "./lib/webVitals";

// Initialize monitoring services
initSentry();
initWebVitals();

createRoot(document.getElementById("root")!).render(
  <App />
);
